module.exports = __webpack_public_path__ + "static/Manta-59b130e27e3065b8c06d83754125843e.png";